module.exports = __webpack_public_path__ + "img/placard_05.81684b5d.png";